import React, { Fragment, useEffect, useState } from "react";
import NavBar from "./pages/Layout/NavBar/NavBar";
import { Outlet, useLocation } from "react-router-dom";
import {
  createTheme,
  Grid,
  ThemeProvider,
  CssBaseline,
  Typography,
} from "@mui/material";
import theme from "./Components/theme/theme";
import WelcomePage from "./WelcomPage";
function App() {
  const [direction, setDirection] = useState("ltr");
  const location = useLocation();

  useEffect(() => {
    const updateDirection = () => {
      const savedDirection = localStorage.getItem("direction");
      setDirection(savedDirection || "ltr");
    };
    updateDirection();
  }, []);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Fragment>
        <NavBar />
        {location?.pathname === "/" ? (
          <WelcomePage />
        ) : (
          <Grid container margin={"0px auto"} className="App" maxWidth={"xl"}>
            <Outlet />
          </Grid>
        )}
      </Fragment>
    </ThemeProvider>
  );
}

export default App;
